export default function WhatsIncluded() {
  return (
    <div className="roboto-regular">
      <div className="py-3">
        <h3 className="font-bold text-2xl mb-2">
          Complete Personal BFR System
        </h3>
        <ul className="list-disc pl-5">
          <li className="py-1 text-xl">2 Arm Bands + 2 Leg Bands + Pump</li>
          <li className="py-1 text-xl">B3 Duffel Bag + Exercise Tubing</li>
          <li className="py-1 text-xl">Video Instructions</li>
        </ul>
      </div>
      <div className="py-0">
        <h3 className="font-bold text-2xl mb-2">
          BFR Guidance <span className="font-semibold">$300 Value</span>
        </h3>
        <ul className="list-disc pl-5">
          <li className="py-1 text-xl">B3 U App: Live & On-Demand BFR</li>
          <li className="py-1 text-xl">Live Guidance from Dr. Mike</li>
          <li className="py-1 text-xl">Access to Dr. Mike’s BFR Tips</li>
          <li className="py-1 text-xl">BFR Diet Course</li>
        </ul>
      </div>
      <div className="py-0">
        <h3 className="font-bold text-2xl mb-2">Plus</h3>
        <ul className="list-disc pl-5">
          <li className="py-1 text-xl">30 Day Money Back Guarantee</li>
          <li className="py-1 text-xl">12 Month Warranty</li>
          <li className="py-1 text-xl">
            Option $0 Down, 0% Interest for 6 Months
          </li>
        </ul>
      </div>
    </div>
  );
}
